const _mascaraTelefoneProspect = (telefone) => {
    if (telefone)
        return telefone.length == 10 ? '#####-####' : '####-#####'
    else
        return '#####-####'
}

const _maskTel = (tel) => {
  if(tel)
    return tel.length == 15 ? '(##) #####-####' : '(##) ####-#####'
  else
    return '(##) #####-####'
}

const _maskDoc = (doc) => {
  if(doc)
    return doc.length == 14 ? '##.###.###/####-##' : '###.###.###-#####';
  else
    return '##.###.###/####-##';
}

const mask = {
    mascaraTelefoneProspect: _mascaraTelefoneProspect,
    maskDoc: _maskDoc,
    maskTel: _maskTel,
}

export default mask;
